<template>
    <legend>
        <ul>
            <li>
                <button @click.prevent="setType('Common')" class="icon common" :class="{active:bobbleType == 'Common'}">
                    <span></span> Common
                </button>
            </li>
            <li>
                <button @click.prevent="setType('Rare')" class="icon rare" :class="{active:bobbleType == 'Rare'}">
                    <span></span> Rare
                </button>
            </li>
            <li>
                <button @click.prevent="setType('Legendary')" class="icon legendary" :class="{active:bobbleType == 'Legendary'}">
                    <span></span> Legendary
                </button>
            </li>
        </ul>
    </legend>
    <div class="swiper" ref="carousel">
        <div class="swiper-wrapper">
            <slot :bobbleType="bobbleType"></slot>
        </div>
    </div>
</template>
<script setup>
import Swiper from 'swiper/bundle';
import { onMounted, ref, nextTick } from 'vue';

const carousel = ref(null);
const bobbleType = ref('');
let swiper = null;

const setType = (t) => {
    if(t != bobbleType.value){
        bobbleType.value = t;
    } else {
        bobbleType.value = '';
    }
    nextTick(()=>{
        swiper.update();
        if(bobbleType.value){
            swiper.slideTo(0, 0);
        } else {
            swiper.slideTo(carousel.value.querySelectorAll('.swiper-slide').length/2, 0);
        }
    })
}

onMounted(()=>{
    swiper = new Swiper(carousel.value, {
        slidesPerView:'auto',
        loop:false,
        grabCursor:true,
        centeredSlides:true,
        initialSlide:Math.ceil(carousel.value.querySelectorAll('.swiper-slide').length/2),
        keyboard:{
            enabled:true,
            onlyInViewport:true,
            pageUpDown:false
        },
        effect:'coverflow',
        coverflowEffect:{
            rotate:0,
            slideShadows:false,
            stretch:-40
        }
    })
})
</script>
